import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { loader } from 'graphql.macro';
import { logger } from 'logging-utils';
import { AuditLogsResponse, GetLogsInput } from '../../types/audit-logs-types';
import { AuditLog } from '@oxappsec/ox-unified-audit-logger';
import { Nullable } from 'common-types';

const query = loader('./get-audit-logs.gql');

const getAuditLogs = (client: ApolloClient<NormalizedCacheObject>) => {
  return {
    execute: async (
      input: GetLogsInput,
      includeCount: boolean,
    ): Promise<Nullable<AuditLogsResponse>> => {
      try {
        const results = await client.query<AuditLogsQueryResponse>({
          query,
          variables: { input, includeCount },
        });

        if (!results || !results.data || !results.data.getLogs) {
          logger.error('Failed to get audit logs');
          return null;
        }

        const { getLogs, getLogsCount } = results.data;

        return {
          auditLogs: getLogs,
          logsCount: getLogsCount?.count,
        } as AuditLogsResponse;
      } catch (error) {
        logger.error('Failed to get audit logs', error);
        return null;
      }
    },
  };
};

interface AuditLogsQueryResponse {
  getLogs: AuditLog[];
  getLogsCount?: {
    count: number;
  };
}

export default getAuditLogs;
